import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';

/**
 * 查询工单考勤记录
 * @param {String} orderId 子工单ID
 */
export const getPunchRecords = (orderId) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/app_attendance_record/punchRecords/${orderId}`,
    method: 'GET'
  });
};

/**
 * 查询考勤罚款配置列表
 * @param {Object} params - { projectType }
 */
export const getAttendanceConfigList = (params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/attendance_penalty_config?` + params,
    method: 'GET'
  });
};

/**
 * 新增考勤罚款配置
 * @param {Object} data - { projectType, configKey, configValue, remark }
 */
export const addAttendanceConfig = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/attendance_penalty_config`,
    method: 'POST',
    data: data
  });
};

/**
 * 修改考勤罚款配置
 * @param {String} id 配置ID
 * @param {Object} data - { projectType, configKey, configValue, remark }
 */
export const updateAttendanceConfig = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/attendance_penalty_config`,
    method: 'POST',
    data: data
  });
};

/**
 * 删除考勤罚款配置
 * @param {String} id 配置ID
 */
export const deleteAttendanceConfig = (id) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/attendance_penalty_config/${id}`,
    method: 'DELETE'
  });
};
